import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "Dashboard" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
